import { NgFor } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Fitter } from '@sc/data-access-models';
import { FitterRouterService } from '@sc/feature-fitter-path-router-system';
import { ButtonComponent } from '@sc/ui-components';
import { PlanningSandboxService } from '../../../services';
import { FitterNameDisplayService } from '@sc/feature-contextual-display';

@Component({
  selector: 'sc-mobile-planning-fitters',
  styleUrls: ['./mobile-planning-fitters.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, ButtonComponent],
  providers: [PlanningSandboxService, FitterNameDisplayService],
  template: `
    <div class="mobile-fitters-container" *ngFor="let fitter of fitters">
      <div class="mobile-fitters-title">
        {{ fitter.brand + ' ' + fitter?.city }}
      </div>
      <div class="mobile-fitters-address">
        {{ fitter?.address }}
      </div>
      <sc-button (click)="goToCalendar(fitter?.id)">Planning</sc-button>
    </div>
  `,
})
export class MobilePlanningFittersComponent implements OnInit {
  fitters: Fitter[];
  constructor(
    private readonly routerService: FitterRouterService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly planningSb: PlanningSandboxService
  ) {}

  ngOnInit() {
    this.planningSb.fetchFitters().subscribe((fitters) => {
      this.fitters = fitters;
      this.changeDetectorRef.detectChanges();
    });
  }

  goToCalendar(fitterId: string) {
    this.routerService.gotToMobileCalendar(fitterId);
  }
}
